import {ACCOUNT_CURRENT_REQUESTED, SET_ASSIGNED, CLEAR_ASSIGNED} from "../../constants/ActionTypes";

export const fetchAccountCurrent = () => ({type: ACCOUNT_CURRENT_REQUESTED});
export const setAssigned = () => ({type: SET_ASSIGNED});
export const clearAssigned = () => ({type: CLEAR_ASSIGNED});
